import type { FrontDeskActorRole } from "./types.ts";

const CHECKIN_ROLES = new Set<FrontDeskActorRole>(["admin", "general_manager", "front_office", "supervisor"]);
const ROOM_MOVE_ROLES = new Set<FrontDeskActorRole>(["admin", "general_manager", "front_office", "supervisor"]);
const CHECKOUT_ROLES = new Set<FrontDeskActorRole>(["admin", "general_manager", "front_office", "finance", "supervisor"]);

export function canRegisterDocument(role: FrontDeskActorRole) {
  return CHECKIN_ROLES.has(role);
}

export function canExecuteCheckin(role: FrontDeskActorRole) {
  return CHECKIN_ROLES.has(role);
}

export function canMoveRoom(role: FrontDeskActorRole) {
  return ROOM_MOVE_ROLES.has(role);
}

export function canExecuteCheckout(role: FrontDeskActorRole) {
  return CHECKOUT_ROLES.has(role);
}

